module.exports = {
	"title": "Overwrite the application title in your own i18n bundle",
	"de": "Deutsch",
	"en": "Englisch",
	"validationError.Str": "Diese Eingabe ist erforderlich",
	"validationError.StrMaxLength": "Diese Eingabe ist erforderlich (max. {0, number} Zeichen)",
	"validationError.Integer": "Nur ganze Zahlen sind erlaubt.",
	"validationError.username": "Bitte geben Sie einen gültigen Benutzernamen ein.",
	"validationError.Password": "Bitte geben Sie ein gültiges Passwort ein.",
	"validationError.PasswordMinChars": "Bitte geben Sie ein gültiges Passwort ein. (min. {minCharsValue, number} Zeichen)",
	"validationError.Bool": "Diese Auswahl ist erforderlich.",
	"validationError.Enums": "Bitte treffen Sie eine Auswahl.",
	"genericStatusError.any": "Server-Befehl fehlgeschlagen (Server nicht erreichbar bzw. Fehlercode nicht definiert).",
	"genericStatusError.code": "Server-Befehl fehlgeschlagen (Fehler: {error}).",
	"genericStatusError.description": "Server-Befehl fehlgeschlagen (Fehler: {error}).",
	"runtimeError": "Laufzeitfehler: {error}.",
	"authProcess.wrongCredentials": "Benutzername/Passwort ungültig oder unzureichende Rechte (Fehler {error}).",
	"authProcess.timeout": "Anmeldung fehlgeschlagen (Server nicht erreichbar).",
	"authProcess.loading": "Anmeldung läuft...",
	"authProcess.globalSecurityError": "Sicherheitsfehler. Sie wurden ausgeloggt. (Fehler {error})",
	"serverValidationError": "'{error}' (Serverfehler)",
	"error": "Fehler",
	"cancel": "Abbrechen",
	"ok": "OK",
	"undo": "Rückgängig",
	"accept": "Akzeptieren",
	"reject": "Ablehnen",
	"save": "Speichern",
	"saveChanges": "Änderungen speichern",
	"dropChanges": "Änderungen verwerfen",
	"close": "Schließen",
	"create": "Erstellen",
	"modified": "bearbeitet",
	"modify": "Bearbeiten",
	"deactivated": "Deaktiviert",
	"delete": "Löschen",
	"disable": "Deaktivieren",
	"enable": "Aktivieren",
	"refresh": "Aktualisieren",
	"filter": "Filtern",
	"resetFilter": "Filter zurücksetzen",
	"back": "Zurück",
	"select": "Auswählen",
	"new": "Neu",
	"newUser": "Neuer Benutzer",
	"logout": "Abmelden",
	"sendEmailToSupport": "Support",
	"login": "Anmelden",
	"search": "Suchen...",
	"noResults": "Keine Ergebnisse",
	"noResultsQuery": "Keine Ergebnisse für '{filter}' gefunden.",
	"loggedInAs": "Angemeldet als {user}",
	"deactivate": "deaktivieren",
	"activate": "aktivieren",
	"notFound.title": "Seite nicht verfügbar!",
	"notFound.body": "Es tut uns Leid, aber Ihre angeforderte Seite existiert nicht.",
	"notFound.link": "Zurück zur Hauptseite",
	"sidebar.separator.content": "Content",
	"sidebar.separator.misc": "Anderes",
	"page.users.title": "Benutzer",
	"page.main.title": "Main (NA)",
	"page.sub.title": "Sub (NA)",
	"schema.id": "#",
	"schema.username": "Benutzername",
	"schema.email": "E-Mail",
	"schema.nickname": "Nickname",
	"schema.password": "Passwort",
	"schema.newPassword": "Neues Passwort (optional)",
	"schema.passwordConfirm": "Passwort bestätigen",
	"schema.newPasswordConfirm": "Neues Passwort bestätigen (optional)",
	"schema.shouldRememberUser": "Anmeldung auf diesem Gerät merken",
	"schema.pk": "#",
	"schema.createdAt": "Erstellt am",
	"schema.updatedAt": "Verändert am",
	"schema.scope": "Rechte",
	"schemaError.username": "Bitte geben Sie einen gültigen Benutzernamen ein.",
	"rowSelection": "Auswahl",
	"paginatorControl.text": "Zeige {from, number} bis {to, number} von {total, number} Ergebnissen.",
	"minutesWithAppendix": "{minutes, number} Minuten",
	"picturecrop.dismiss": "Zurücksetzen",
	"picturecrop.freemove": "Frei positionieren",
	"picturecrop.drophere": "Bild hier ablegen",
	"users.create": "Benutzer hinzufügen",
	"users.modify": "Benutzer bearbeiten",
	"pictureUploadProcess.failed": "Das Hochladen des Bildes ist fehlgeschlagen (Format und Bildgröße überprüfen, Fehler {error}).",
	"picturecrop.minimalSize": "Minimal-Größe: {width}x{height}",
	"day": "Tag",
	"from": "Von",
	"to": "Bis",
	"weekday.mo": "Montag",
	"weekday.tu": "Dienstag",
	"weekday.we": "Mittwoch",
	"weekday.th": "Donnerstag",
	"weekday.fr": "Freitag",
	"weekday.sa": "Samstag",
	"weekday.su": "Sonntag",
	"confirm.delete.user.title": "Wollen Sie den ausgewählten Benutzer wirklich löschen?",
	"login.page.forgotPassword.button": "Passwort vergessen",
	"login.modal.forgotPassword.title": "Passwort vergessen",
	"forgotPassword.email.username": "Benutzername",
	"forgotPassword.email.error": "Bitte geben Sie einen gültigen Benutzernamen ein.",
	"forgotPassword.success": "Eine Email mit Anweisungen für die Password-Rücksendung wurde Ihnen zugesendet",
	"send": "Abschicken",
	"createdAt": "Erstellt am",
	"reportDetail.steps.uploadImage": "Hochladen",
	"reportDetail.steps.deleteImage": "Löschen"
};


/*****************
 ** WEBPACK FOOTER
 ** ./src/i18n/de.json
 ** module id = 902
 ** module chunks = 0
 **/